import { render, staticRenderFns } from "./vipFreeInfo.vue?vue&type=template&id=a9eb0f10&scoped=true&"
import script from "./vipFreeInfo.vue?vue&type=script&lang=ts&"
export * from "./vipFreeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./vipFreeInfo.vue?vue&type=style&index=0&id=a9eb0f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9eb0f10",
  null
  
)

export default component.exports